export const uniqueIdentifierEnum = {
  StudentNumber: 1,
  ServingNumber: 0,
};

export const uniqueIdentifierOptions = [
  { label: 'Student Number', value: uniqueIdentifierEnum.StudentNumber },
  { label: 'Serving Number', value: uniqueIdentifierEnum.ServingNumber },
];

export const sortByEnum = {
  StudentName: 0,
  TeacherName: 1,
};

export const sortByOptions = [
  { label: 'Student Name', value: 0 },
  { label: 'Teacher Name', value: 1 },
];

export const displayOptions = [
  {
    name: 'DisplayUniqueIdentifier',
    label: 'Unique Identifier',
    checked: true,
  },
  { name: 'DisplayBarcode', label: 'Barcode', checked: true },
  { name: 'DisplayPicture', label: 'Picture', checked: false },
  { name: 'DisplaySiteName', label: 'Site Name', checked: false },
];

export const defaultReportModel = {
  MealStatus: [],
  UniqueIdentifierStudentNumber: '',
  DisplayUniqueIdentifier: true,
  DisplayBarcode: true,
  DisplayPicture: false,
  DisplaySiteName: false,
  SortBy: 0,
  FilterBySiteId: [],
  FilterByTeacherName: '',
  FilterByStudentNumber: [],
};



// WEBPACK FOOTER //
// ./src/pages/idcards/Constants.js